import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/customer/shop/components/pl_FilterSidebar.css";

const priceRanges = [
  { id: 1, label: "Under Rs10,000", min: 0, max: 10000 },
  { id: 2, label: "Rs10,000 - Rs25,000", min: 10000, max: 25000 },
  { id: 3, label: "Rs25,000 - Rs50,000", min: 25000, max: 50000 },
  { id: 4, label: "Above Rs50,000", min: 50000, max: 999999 },
];

const discountOptions = [
  { id: 1, label: "10% or more", min: 10 },
  { id: 2, label: "20% or more", min: 20 },
  { id: 3, label: "30% or more", min: 30 },
];

const FilterSidebar = ({ onFilterChange, activeFilters }) => {
  const [openSections, setOpenSections] = useState({
    categories: true,
    price: true,
    materials: false,
    colors: false,
    availability: false,
    discount: false,
  });

  const { baseUrl } = useContext(AppContext);
  const [categories, setCategories] = useState([]);

  const fetchCategories = () => {
    axios
      .get(`${baseUrl}/customer/category/getCategories`)
      .then((response) => {
        console.log(response.data);
        setCategories(response.data.categories);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  // Toggle section open/close
  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  // Handle category filter
  const handleCategoryChange = (categoryId) => {
    onFilterChange("category", categoryId);
  };

  // Handle price range filter
  const handlePriceChange = (range) => {
    onFilterChange("priceRange", range);
  };

  // Handle discount filter
  const handleDiscountChange = (discount) => {
    onFilterChange("discount", discount);
  };

  // Clear all filters
  const clearAllFilters = () => {
    onFilterChange("clearAll", null);
  };

  return (
    <aside className="pl-filter-sidebar">
      {/* Sidebar Header */}
      <div className="pl-filter-header">
        <h2 className="pl-filter-title">Filters</h2>
        {Object.keys(activeFilters).length > 0 && (
          <button className="pl-clear-btn" onClick={clearAllFilters}>
            Clear All
          </button>
        )}
      </div>

      {/* Active Filters Count */}
      {Object.keys(activeFilters).length > 0 && (
        <div className="pl-active-filters">
          <span className="pl-filter-count">
            {Object.keys(activeFilters).length} filter(s) active
          </span>
        </div>
      )}

      {/* Filter Sections */}
      <div className="pl-filter-sections">
        {/* Categories Filter */}
        <div className="pl-filter-section">
          <button
            className="pl-section-header"
            onClick={() => toggleSection("categories")}
          >
            <span className="pl-section-title">Categories</span>
            <svg
              className={`pl-chevron ${openSections.categories ? "pl-chevron-open" : ""}`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          {openSections.categories && (
            <div className="pl-section-content">
              {categories.map((category) => (
                <button
                  key={category.id}
                  className={`pl-category-button ${
                    activeFilters.category === category.id
                      ? "pl-category-active"
                      : ""
                  }`}
                  onClick={() => handleCategoryChange(category.id)}
                >
                  <span className="pl-category-label">{category.name}</span>
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Price Range Filter */}
        <div className="pl-filter-section">
          <div className="pl-section-header-static">
            <span className="pl-section-title">Price Range</span>
          </div>

          <div className="pl-section-content">
            <div className="pl-radio-group">
              {priceRanges.map((range) => (
                <label key={range.id} className="pl-radio-item">
                  <input
                    type="radio"
                    name="priceRange"
                    className="pl-radio-input"
                    checked={activeFilters.priceRange?.id === range.id}
                    onChange={() => handlePriceChange(range)}
                  />
                  <span className="pl-radio-custom"></span>
                  <span className="pl-radio-label">{range.label}</span>
                </label>
              ))}
            </div>
          </div>
        </div>

        {/* Discount Filter */}
        <div className="pl-filter-section">
          <button
            className="pl-section-header"
            onClick={() => toggleSection("discount")}
          >
            <span className="pl-section-title">Discount</span>
            <svg
              className={`pl-chevron ${openSections.discount ? "pl-chevron-open" : ""}`}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </button>

          {openSections.discount && (
            <div className="pl-section-content">
              {discountOptions.map((option) => (
                <label key={option.id} className="pl-filter-item">
                  <input
                    type="radio"
                    name="discount"
                    className="pl-radio"
                    checked={activeFilters.discount?.min === option.min}
                    onChange={() => handleDiscountChange(option)}
                  />
                  <span className="pl-filter-label">{option.label}</span>
                </label>
              ))}
            </div>
          )}
        </div>
      </div>
    </aside>
  );
};

export default FilterSidebar;
